import { render, staticRenderFns } from "./el-spinner.vue?vue&type=template&id=0a629f3c"
import script from "./el-spinner.vue?vue&type=script&lang=js"
export * from "./el-spinner.vue?vue&type=script&lang=js"
import style0 from "./el-spinner.vue?vue&type=style&index=0&id=0a629f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports